module.exports = __webpack_public_path__ + "static/img/patent-swiper-7.75145e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/patent-swiper-7.png
// module id = FTe8
// module chunks = 1